if (!customElements.get('announcement-bar-custom')) {
  customElements.define(
    'announcement-bar-custom',
    class AnnouncementBarCustom extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('.abc-viewport');
        this.tracks = Array.from(this.querySelectorAll('.abc-track'));
        if (!this.viewport || this.tracks.length === 0) return;

        // Snapshot the original run rendered by Liquid so we can rebuild
        // tracks predictably on resize / font load.
        this.originalRun = Array.from(this.tracks[0].children).map((node) => node.cloneNode(true));
        if (this.originalRun.length === 0) return;

        this.fillTracks = this.fillTracks.bind(this);
        this.fillTracks();

        // Webfonts can change run width after load; re-fill once they're ready.
        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(this.fillTracks).catch(() => {});
        }

        // Throttle resize via rAF.
        this.onResize = () => {
          if (this.rafId) return;
          this.rafId = requestAnimationFrame(() => {
            this.rafId = null;
            this.fillTracks();
          });
        };
        window.addEventListener('resize', this.onResize);
      }

      disconnectedCallback() {
        if (this.onResize) window.removeEventListener('resize', this.onResize);
        if (this.rafId) cancelAnimationFrame(this.rafId);
      }

      fillTracks() {
        const viewportWidth = this.viewport.clientWidth;
        if (!viewportWidth) return;

        // Reset every track to a single original run before re-measuring.
        for (const track of this.tracks) {
          const fresh = this.originalRun.map((n) => n.cloneNode(true));
          track.replaceChildren(...fresh);
        }

        const baseRunWidth = this.tracks[0].scrollWidth;
        if (baseRunWidth === 0 || baseRunWidth >= viewportWidth) return;

        // How many copies of the run per track so its width covers the viewport.
        // Each track already has 1 copy, so we append (copies - 1) more.
        const copies = Math.ceil(viewportWidth / baseRunWidth);
        for (const track of this.tracks) {
          for (let i = 1; i < copies; i++) {
            for (const node of this.originalRun) {
              track.appendChild(node.cloneNode(true));
            }
          }
        }
      }
    },
  );
}
